import React, { Fragment } from "react";
import moment from "moment-timezone";

import SemanticUiModal from "../semantic_ui_modal";
import { getText } from "../../helpers";
import ActivityDescription from "./activity_description";
import InspectionsTable from "./inspection_table";

export default function InspectionDetails(props) {
  const { workPhase, activity, inspections, hideInspectionDetails } = props;

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = moment().tz(timezone).zoneAbbr();
  const timeZoneOffset = moment().format("Z");
  const timezoneDesc = `${timezone} (${timezoneAbbr} UTC${timeZoneOffset})`;

  return (
    <SemanticUiModal
      modalOptions={{
        className: "inspectiond-details-modal",
      }}
      header={
        <Fragment>
          <div>{getText("Inspection Details")}</div>
          <ActivityDescription workPhase={workPhase} activity={activity} />
        </Fragment>
      }
      content={
        <Fragment>
          <div className="timezone-description">
            {getText("Timezone")}: {timezoneDesc}
          </div>
          <InspectionsTable inspections={inspections} />
        </Fragment>
      }
      closeModal={hideInspectionDetails}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/inspection_details.js